import React, {useEffect, useState, useRef} from "react";
import {connect} from "react-redux";
import "../../styles/businessBackofficeStyles.scss";
import {brand} from "../../../config";
import { ListTodo, Folders, Inbox as InboxIcon, Flag, BotMessageSquare, Target, Workflow, Blocks, LogOut, LayoutDashboard, ChartBarStacked, Box, Settings, LayoutPanelLeft, PackageSearch, Bot, Menu, X, ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import mantisLogo from "../../../Assets/img/mantisBlackLogo.png";
import mantisBlackLogo from "../../../Assets/img/icons/b2b/mantisBlack.png";
import mantisWhiteLogo from "../../../Assets/img/icons/b2b/mantisWhite.png";
import sandyLogo from "../../../Assets/img/sandyIsotype.png";
import mantisWhiteCompleteLogo from "../../../Assets/img/mantisWhiteLogo2.png";
import mantisBlackCompleteLogo from "../../../Assets/img/mantisBlackLogo.png";
import FormBuilderApp from "../../../MantisBusiness/Sections/Forms/form-builder-app"
import sandyCompleteLogo from "../../../Assets/img/sandyBlackLogo.png";
import "../../../Assets/img/icons/b2b/bellWhite.png";
import "../../../Assets/img/icons/b2b/bellBlack.png";
import Employees from "../Employees/Employees";
import "../Documents/Archive";
import { businessLogout } from "../../../ApiCalls/authentication";
import { userLogout } from "../../../Redux/modules/auth";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import {
  getMantisBusinessNotificationNumber,
  generateSetupFeeSubscriptionCheckout,
} from "../../../ApiCalls/mantisBusiness";
import BusinessNotifications from "./BusinessNotifications";
import "../../../utils/businessUtils";
import "./BusinessUsers";
import BusinessAssistant from "./BusinessAssistant";
import { Modal } from "react-bootstrap";

import "./BusinessMissions";
import "./BusinessArchive";
import ArchivesSection from "../Documents/ArchivesSection";
import HelpPanel from "../../Extras/HelpPanel";
import BusinessDashboard from "./BusinessDashboard";
import BusinessExtraction from "./BusinessExtraction";
import "../Documents/DocumentSection";
import "../Correspondence/Correspondence";
import Inbox from "../User/Inbox";
import DocumentActions from "../Documents/DocumentActions";
import Flows from "../Flows/Flows";
import FlowCreator from "../FlowCreator/FlowCreator";
import FlowManagement from "../FlowManagement/FlowManagement";
import DocumentManager from "../Documents/Document";
import "../../Extras/ThemeToggle";
import "../../styles/Navbar.css";
import { selectAuthState } from "../../../store/selectors/authSelectors";
import {isMobileDevice} from "../../../utils/deviceDetection";

import InventoryManagement from "../Inventory/InventoryManagment";
import ConfigurationModal from "./components/ConfigurationModal";
import ControlPanel from "../ControlPanel/ControlPanel";
import BusinessAgentsSection from "./BusinessAgentsSection";

import Products from "../Products/Products";
import BudgetDashboard from "../Dashboard/BudgetDashboard";
import FinancialAnalysis from "../FinancialAnalysis/FinancialAnalysis";
import Outlets from "../Outlets/Outlets";
import RequisitionsDashboard from "../Dashboard/RequisitionsDashboard/RequisitionsDashboard";
import ClientTypeTaktik from "../Taktik/ClientTypeTaktik";
// import LanguageSelector from "../../../components/LanguageSelector";
// import TranslationStatus from "../../../components/TranslationStatus";
// import { useAutoTranslate } from "../../../hooks/useAutoTranslate";
// import SimpleTranslateButton from "../../../components/SimpleTranslateButton";

// Componente Language Selector integrado con Clean UI
const LanguageSelectorClean = ({
  currentLang,
  isTranslating,
  isObserving,
  sidebarExpanded,
  onTranslate,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const languages = [
    { code: "es", name: "Español", flag: "🇪🇸" },
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "fr", name: "Français", flag: "🇫🇷" },
    { code: "ar", name: "العربية", flag: "🇸🇦" },
    { code: "zh", name: "中文", flag: "🇨🇳" },
  ];

  const currentLanguage =
    languages.find((l) => l.code === currentLang) || languages[0];
  const apiKey = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY;

  const handleLanguageChange = async (languageCode) => {
    if (languageCode === currentLang || isTranslating) {
      return;
    }
    setIsOpen(false);
    await onTranslate(languageCode);
  };

  // Si no hay API Key
  if (!apiKey || apiKey === "TU_API_KEY_AQUI") {
    return (
      <div
        className="sidebar-item justify-center"
        title="API Key requerida"
        data-no-translate
      >
        {sidebarExpanded ? (
          <div className="flex items-center space-x-2 w-full px-3 py-2 rounded-lg border border-red-300 bg-red-50 dark:bg-red-900/20 dark:border-red-700">
            <span className="text-red-600 dark:text-red-400">⚠️</span>
            <span className="text-xs text-red-600 dark:text-red-400 font-medium">
              API Key requerida
            </span>
          </div>
        ) : (
          <div className="w-10 h-10 rounded-lg border border-red-300 bg-red-50 dark:bg-red-900/20 dark:border-red-700 flex items-center justify-center">
            <span className="text-red-600 dark:text-red-400 text-xs">⚠️</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className="sidebar-item justify-center"
      title="Cambiar idioma"
      data-no-translate
    >
      <div className="relative w-full" ref={dropdownRef}>
        {sidebarExpanded ? (
          // Sidebar expandido - Versión completa
          <>
            <button
              onClick={() => setIsOpen(!isOpen)}
              disabled={isTranslating}
              className={`w-full flex items-center justify-between px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-600 bg-white/80 dark:bg-slate-700/80 backdrop-blur-sm hover:bg-slate-50 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 transition-all duration-200 shadow-sm hover:shadow text-sm font-medium ${
                isTranslating
                  ? "opacity-60 cursor-not-allowed"
                  : "cursor-pointer"
              }`}
            >
              <div className="flex items-center space-x-2">
                <span className="text-lg">{currentLanguage.flag}</span>
                <span>{currentLanguage.name}</span>
              </div>

              {isTranslating ? (
                <div className="w-4 h-4 border-2 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
              ) : (
                <ChevronDown
                  className={`w-4 h-4 transition-transform duration-200 ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              )}
            </button>

            {/* Dropdown */}
            <AnimatePresence>
              {isOpen && (
                <motion.div
                  initial={{ opacity: 0, y: -10, scale: 0.95 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -10, scale: 0.95 }}
                  transition={{ duration: 0.2, ease: "easeOut" }}
                  className="language-dropdown top-full left-0 mt-2 w-full max-h-64 overflow-y-auto"
                >
                  {languages.map((language, index) => (
                    <motion.button
                      key={language.code}
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.05, duration: 0.2 }}
                      onClick={() => handleLanguageChange(language.code)}
                      className={`language-option ${
                        currentLang === language.code ? "active" : ""
                      }`}
                    >
                      <div className="option-content">
                        <span className="flag">{language.flag}</span>
                        <div className="text-content">
                          <div className="language-name">{language.name}</div>
                        </div>
                        {currentLang === language.code && (
                          <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            className="selected-indicator"
                          ></motion.div>
                        )}
                      </div>
                    </motion.button>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>

            {/* Estado del observador */}
            {isObserving && currentLang !== "es" && (
              <div className="translation-status">
                <div className="status-dot"></div>
                <span className="status-text">Auto-traduciendo</span>
              </div>
            )}
          </>
        ) : (
          // Sidebar colapsado - Versión mini
          <>
            <button
              onClick={() => setIsOpen(!isOpen)}
              disabled={isTranslating}
              className={`w-10 h-10 p-0 rounded-lg border border-slate-200 dark:border-slate-600 bg-white/80 dark:bg-slate-700/80 backdrop-blur-sm hover:bg-slate-50 dark:hover:bg-slate-600 transition-all duration-200 shadow-sm hover:shadow flex items-center justify-center relative ${
                isTranslating
                  ? "opacity-60 cursor-not-allowed"
                  : "cursor-pointer"
              }`}
            >
              {isTranslating ? (
                <div className="w-4 h-4 border-2 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
              ) : (
                <span className="text-lg">{currentLanguage.flag}</span>
              )}

              {/* Indicador de auto-traducción */}
              {isObserving && currentLang !== "es" && (
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
              )}
            </button>

            {/* Dropdown para versión mini */}
            <AnimatePresence>
              {isOpen && (
                <motion.div
                  initial={{ opacity: 0, x: -10, scale: 0.95 }}
                  animate={{ opacity: 1, x: 0, scale: 1 }}
                  exit={{ opacity: 0, x: -10, scale: 0.95 }}
                  transition={{ duration: 0.2, ease: "easeOut" }}
                  className="language-dropdown top-0 left-12 w-48 max-h-64 overflow-y-auto"
                >
                  {languages.map((language, index) => (
                    <motion.button
                      key={language.code}
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.05, duration: 0.2 }}
                      onClick={() => handleLanguageChange(language.code)}
                      className={`language-option ${
                        currentLang === language.code ? "active" : ""
                      }`}
                    >
                      <div className="option-content">
                        <span className="flag">{language.flag}</span>
                        <div className="text-content">
                          <div className="language-name">{language.name}</div>
                        </div>
                        {currentLang === language.code && (
                          <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            className="selected-indicator"
                          ></motion.div>
                        )}
                      </div>
                    </motion.button>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </>
        )}
      </div>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    userLogout: () => dispatch(userLogout()),
  };
}

function BusinessBackOffice(props) {
  const {activeTab} = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [sidebarExpandedWidth] = useState(200);
  const [sidebarCollapsedWidth] = useState(100);
  const [sidebarTransitionTime] = useState(0.2);

  const [helpPanelExpandedWidth, setHelpPanelExpandedWidth] = useState(300);
  const [helpPanelCollapsedWidth, setHelpPanelCollapsedWidth] = useState(50);
  const [helpPanelTransitionTime] = useState(0.2);
  
  // Determinar la sección activa basada en la URL
  const determineActiveSection = () => {
    const pathname = location.pathname;

    // Verificar si es una ruta de control-panel-p2o (con o sin IPR ID)
    if (pathname.includes("/control-panel-p2o")) {
      return "CONTROL_PANEL_P2O";
    }

    // Verificar si es una ruta de outlets
    if (pathname.includes("/outlets")) {
      return "OUTLETS";
    }

    // Verificar si es la ruta de agents
    if (pathname.includes("/agents")) {
      return "AGENTS";
    }

    // Lógica existente para otras rutas
    if (activeTab) {
      return activeTab.toUpperCase().replace(/-/g, "_");
    }

    return props.mantisBusiness.enabledSections
      ? props.mantisBusiness.enabledSections[0]
      : "DASHBOARD";
  };

  const [activeSection, setActiveSection] = useState(determineActiveSection());

  useEffect(() => {
    const newActiveSection = determineActiveSection();
    setActiveSection(newActiveSection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, location.pathname]);

  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileDeviceType, setIsMobileDeviceType] = useState(false);
  const [helpPanelExpanded, setHelpPanelExpanded] = useState(false);
  const [hoverButtons, setHoverButtons] = useState({
    employees: false,
    archive: false,
    notifications: false,
    users: false,
    assistant: false,
    logout: false,
    profile: false,
    missions: false,
    dashboard: false,
    controlPanel: false,
    taktik: false,
    documentManager: false,
    products: false,
    budgetDashboard: false,
    financialAnalysis: false,
    configuration: false,
    outlets: false,
    navbarToggle: false,
    requisitionsDashboard: false
  });
  const [, setNotificationAmount] = useState(0);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isDarkTheme, setIsDarkTheme] = useState(
    document.documentElement.classList.contains("dark")
  );
  const [clientId] = useState(props.mantisBusiness._id);

  // Translation state - Integrado directamente
  const [isTranslating, setIsTranslating] = useState(false);
  const [currentLang, setCurrentLang] = useState("es");
  const [isObserving, setIsObserving] = useState(false);
  const observerRef = useRef(null);
  const isObservingRef = useRef(false);

  // Funciones de traducción integradas
  const translateElements = async (elements, targetLang) => {
    const apiKey = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY;

    if (!apiKey || apiKey === "TU_API_KEY_AQUI" || !elements.length) {
      return;
    }

    try {
      const untranslatedNodes = [];
      elements.forEach((node) => {
        if (
          node.nodeValue &&
          node.nodeValue.trim().length > 0 &&
          !node.parentElement.closest(
            "script, style, code, [data-no-translate], .no-translate"
          ) &&
          !node.parentElement.hasAttribute("data-translated")
        ) {
          untranslatedNodes.push(node);
        }
      });

      if (untranslatedNodes.length === 0) return;

      const batchSize = 10;
      for (let i = 0; i < untranslatedNodes.length; i += batchSize) {
        const batch = untranslatedNodes.slice(i, i + batchSize);
        const texts = batch.map((node) => node.textContent.trim());

        const response = await fetch(
          `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`,
          {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
              q: texts,
              target: targetLang,
              source: "es",
              format: "text"
            })
          }
        );

        if (response.ok) {
          const data = await response.json();
          data.data.translations.forEach((translation, index) => {
            const node = batch[index];
            if (!node.parentElement.hasAttribute("data-original-text")) {
              node.parentElement.setAttribute(
                "data-original-text",
                node.textContent
              );
            }
            node.textContent = translation.translatedText;
            node.parentElement.setAttribute("data-translated", targetLang);
          });
        }
      }
    } catch (error) {
      console.error("Error traduciendo elementos:", error);
    }
  };

  const getTextNodes = (element = document.body) => {
    const textNodes = [];
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        if (
          node.nodeValue.trim().length > 0 &&
          !node.parentElement.closest(
            "script, style, code, [data-no-translate], .no-translate"
          )
        ) {
          return NodeFilter.FILTER_ACCEPT;
        }
        return NodeFilter.FILTER_REJECT;
      }
    });

    let node;
    while ((node = walker.nextNode())) {
      textNodes.push(node);
    }
    return textNodes;
  };

  const startObserver = (targetLang) => {
    if (observerRef.current || isObservingRef.current || targetLang === "es") {
      return;
    }

    observerRef.current = new MutationObserver((mutations) => {
      const newTextNodes = [];

      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const textNodes = getTextNodes(node);
              newTextNodes.push(...textNodes);
            } else if (
              node.nodeType === Node.TEXT_NODE &&
              node.nodeValue.trim()
            ) {
              newTextNodes.push(node);
            }
          });
        }
      });

      if (newTextNodes.length > 0) {
        translateElements(newTextNodes, targetLang);
      }
    });

    observerRef.current.observe(document.body, {
      childList: true,
      subtree: true
    });

    isObservingRef.current = true;
    setIsObserving(true);
  };

  const stopObserver = () => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
      isObservingRef.current = false;
      setIsObserving(false);
    }
  };

  const translatePage = async (targetLang) => {
    const apiKey = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY;

    if (!apiKey || apiKey === "TU_API_KEY_AQUI") {
      return;
    }

    setIsTranslating(true);

    try {
      if (targetLang === "es") {
        stopObserver();

        const elements = document.querySelectorAll("[data-original-text]");
        elements.forEach((element) => {
          const original = element.getAttribute("data-original-text");
          if (original) {
            element.textContent = original;
            element.removeAttribute("data-original-text");
            element.removeAttribute("data-translated");
          }
        });
        setCurrentLang("es");
        setIsTranslating(false);
        return;
      }

      const textNodes = getTextNodes();
      await translateElements(textNodes, targetLang);

      stopObserver();
      startObserver(targetLang);

      setCurrentLang(targetLang);
    } catch (error) {
      console.error("Error de traducción:", error);
    } finally {
      setIsTranslating(false);
    }
  };

  // Limpiar observer al desmontar
  useEffect(() => {
    return () => {
      stopObserver();
    };
  }, []);

  /* useEffect(() => {
    getNotifications();
  }, []); */

  // Detect device type (not screen size)
  useEffect(() => {
    setIsMobileDeviceType(isMobileDevice());
  }, []);

  // Manejar comportamiento responsive del sidebar
  useEffect(() => {
    const handleResize = () => {
      const isMobileView = window.innerWidth < 768; // md breakpoint en Tailwind
      setIsMobile(isMobileView);
      if (!isMobileView) {
        setSidebarVisible(true); // En desktop siempre visible
      }
    };

    // Ejecutar al montar el componente
    handleResize();

    // Agregar listener para cambios de tamaño
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Hide sidebar initially on mobile for Roldan client type
  useEffect(() => {
    const isRoldanClient =
      props.mantisBusiness?.clientType === "ROLDAN" ||
      props.mantisBusiness?.clientType === "LOGISTICS_DEMO";
    const isClientTypeTaktik = activeSection === "CLIENT_TYPE_TAKTIK";

    if (isMobileDeviceType && isRoldanClient && isClientTypeTaktik) {
      setSidebarVisible(false);
    } else if (!isMobileDeviceType) {
      // On desktop, always show sidebar
      setSidebarVisible(true);
    }
  }, [isMobileDeviceType, activeSection, props.mantisBusiness?.clientType]);

  useEffect(() => {
    if (activeSection !== "ASSISTANT") {
      setHelpPanelCollapsedWidth(0);
      setHelpPanelExpanded(false);
    } else {
      setHelpPanelCollapsedWidth(50);
      setHelpPanelExpandedWidth(400);
    }
  }, [activeSection]);

  useEffect(() => {
    let trueCount = Object.values(hoverButtons).filter((value) => value).length;
    if (trueCount > 1) {
      clearHoverButtons();
    }
  }, [hoverButtons]);

  /*  useEffect(() => {
    const interval = setInterval(() => {
      getNotifications();
    }, 10000);
    return () => clearInterval(interval);
  }, []); */

  const clearHoverButtons = () => {
    setHoverButtons({
      employees: false,
      archive: false,
      notifications: false,
      users: false,
      assistant: false,
      logout: false,
      profile: false,
      missions: false,
      dashboard: false,
      controlPanel: false,
      taktik: false,
      documentManager: false,
      products: false,
      budgetDashboard: false,
      financialAnalysis: false,
      configuration: false,
      outlets: false,
      navbarToggle: false,
      requisitionsDashboard: false,
    });
  };

  
  const handleLogout = async () => {
    // L-01 (MA-06): the JWT lives in an httpOnly cookie now — businessLogout() sends
    // it automatically and the backend clears the cookie on its end.
    await businessLogout();
    props.userLogout();
    navigate("/");
  };

  const calculateViewPanelWidth = () => {
    // En móviles cuando el sidebar está oculto
    if (isMobile && !sidebarVisible) {
      return helpPanelExpanded
        ? `calc(100vw - ${helpPanelExpandedWidth}px)`
        : "100vw";
    }

    // En móviles cuando el sidebar está visible
    if (isMobile && sidebarVisible) {
      const sidebarWidth = sidebarExpanded
        ? sidebarExpandedWidth
        : sidebarCollapsedWidth;
      return helpPanelExpanded
        ? `calc(100vw - ${sidebarWidth + helpPanelExpandedWidth}px)`
        : `calc(100vw - ${sidebarWidth}px)`;
    }

    // En desktop
    if (sidebarExpanded && !helpPanelExpanded) {
      return `calc(100vw - ${sidebarExpandedWidth}px)`;
    } else if (sidebarExpanded && helpPanelExpanded) {
      return `calc(100vw - ${sidebarExpandedWidth + helpPanelExpandedWidth}px)`;
    } else if (!sidebarExpanded && helpPanelExpanded) {
      return `calc(100vw - ${
        helpPanelExpandedWidth + sidebarCollapsedWidth
      }px)`;
    } else {
      return `calc(100vw - ${
        sidebarCollapsedWidth + helpPanelCollapsedWidth
      }px)`;
    }
  };

  const calculateViewPanelLeft = () => {
    // En móviles cuando el sidebar está oculto
    if (isMobile && !sidebarVisible) {
      return "0px";
    }

    // Para todos los demás casos (móvil con sidebar visible y desktop)
    return sidebarExpanded
      ? `${sidebarExpandedWidth}px`
      : `${sidebarCollapsedWidth}px`;
  };

  
  const handlePaymentClick = async () => {
    try {
      // Prepare subscription data based on business plan
      const subscriptionData = {
        subscriptionAmount: props.mantisBusiness.businessPlan.price,
        description: `${props.mantisBusiness.businessPlan.setupFeeUpfrontPercentage}% del desarrollo adicional`,
        setupFee: (() => {
          // If there's a setup fee and upfront percentage, use upfront amount
          if (
            props.mantisBusiness.businessPlan.setupFee &&
            props.mantisBusiness.businessPlan.setupFeeUpfrontPercentage
          ) {
            const upfrontAmount = Math.ceil(
              (props.mantisBusiness.businessPlan.setupFee *
                props.mantisBusiness.businessPlan.setupFeeUpfrontPercentage) /
                100,
            );
            return upfrontAmount;
          }
          // If there's a setup fee and installments, use first installment
          if (
            props.mantisBusiness.businessPlan.setupFee &&
            props.mantisBusiness.businessPlan.setupFeeInstallments > 1
          ) {
            const firstInstallment = Math.ceil(
              props.mantisBusiness.businessPlan.setupFee /
                props.mantisBusiness.businessPlan.setupFeeInstallments,
            );
            return firstInstallment;
          }
          // Otherwise use regular setup fee
          return props.mantisBusiness.businessPlan.setupFee || 0;
        })(),
        currency: props.mantisBusiness.businessPlan.currency || "usd",
        customer_email: props.user?.email,
        metadata: {
          businessId: props.mantisBusiness._id,
          planId: props.mantisBusiness.businessPlan._id || "unknown",
          planType: "subscription",
          setupFee: props.mantisBusiness.businessPlan.setupFee,
          setupFeeInstallments:
            props.mantisBusiness.businessPlan.setupFeeInstallments,
        },
        success_url: `${window.location.origin}/business/backoffice`,
        cancel_url: `${window.location.origin}/business/backoffice`,
        subscriptionInterval:
          props.mantisBusiness.businessPlan.paymentCadence === "monthly"
            ? "month"
            : "year",
        subscriptionIntervalCount: 1,
        trialPeriodDays: props.mantisBusiness.businessPlan.trialDays || null,
      };

      // Generate setup fee subscription checkout
      const result = await generateSetupFeeSubscriptionCheckout(
        props.token,
        subscriptionData,
      );

      if (result.success && result.data?.checkoutUrl) {
        // Open Stripe checkout page in new window
        window.open(result.data.checkoutUrl, "_blank");
      } else {
        console.error("Error generating checkout:", result.error);
        alert("Error al generar el checkout. Por favor, inténtalo de nuevo.");
      }
    } catch (error) {
      console.error("Error in payment process:", error);
      alert("Error en el proceso de pago. Por favor, inténtalo de nuevo.");
    }
  };

  return (
    <div className="business-backoffice-container">
      <div
        className={`sidebar-clean fixed left-0 top-0 h-screen z-40 transition-all duration-300 ease-in-out ${
          !sidebarVisible && isMobile
            ? "transform -translate-x-full opacity-0"
            : "transform translate-x-0 opacity-100"
        }`}
        style={{
          width: sidebarExpanded
            ? `${sidebarExpandedWidth}px`
            : `${sidebarCollapsedWidth}px`,
        }}
        onMouseEnter={() => {
          if (!isMobile) {
            setSidebarExpanded(true);
          }
        }}
        onMouseLeave={() => {
          if (!isMobile) {
            setSidebarExpanded(false);
            setHoverButtons({
              employees: false,
              archive: false,
              notifications: false,
              users: false,
              assistant: false,
              logout: false,
              outlets: false,
            });
          }
        }}
      >
        {/* Logo Section */}
        <div className="flex items-center justify-center py-6 px-4 border-b border-slate-200 dark:border-slate-700">
          {!sidebarExpanded ? (
            <img
              src={
                brand === "MANTIS"
                  ? isDarkTheme
                    ? mantisWhiteLogo
                    : mantisBlackLogo
                  : sandyLogo
              }
              alt="Mantis logo"
              className="w-10 h-10 object-contain"
            />
          ) : (
            <img
              src={
                brand === "MANTIS"
                  ? isDarkTheme
                    ? mantisWhiteCompleteLogo
                    : mantisBlackCompleteLogo
                  : sandyCompleteLogo
              }
              alt="Mantis logo"
              className={`object-contain ${brand === "SANDY" ? "h-12" : "h-8"}`}
            />
          )}
        </div>

        {/* Navigation Section */}
        <nav className="flex-1 px-3 py-4 space-y-2 overflow-y-auto scrollbar-clean">
          {props.mantisBusiness.enabledSections?.map((section) => {
            if (section === "FLOW_MANAGEMENT") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "FLOW_MANAGEMENT" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("FLOW_MANAGEMENT");
                    navigate("/business/backoffice/flow-management", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <LayoutDashboard className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Taktik
                    </span>
                  )}
                </div>
              );
            } else if (section === "FLOWS" && props.user.mantisMainUser) {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "FLOWS" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("FLOWS");
                    navigate("/business/backoffice/flows", { replace: true });
                    clearHoverButtons();
                  }}
                >
                  <Workflow className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Flujos
                    </span>
                  )}
                </div>
              );
            } else if (section === "TAKTIK") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "TAKTIK" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("TAKTIK");
                    navigate("/business/backoffice/taktik", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <LayoutDashboard className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Taktik
                    </span>
                  )}
                </div>
              );
            } else if (section === "FLOW_CREATOR") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "FLOW_CREATOR" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("FLOW_CREATOR");
                    navigate("/business/backoffice/flow-creator", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <Workflow className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Flow Creator
                    </span>
                  )}
                </div>
              );
            } else if (section === "FILLING_FORM") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "FILLING_FORM" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("FILLING_FORM");
                    navigate("/business/backoffice/filling-form", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <Target className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Crear Radicado
                    </span>
                  )}
                </div>
              );
            } else if (section === "INBOX") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "INBOX" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("INBOX");
                    navigate("/business/backoffice/inbox", { replace: true });
                    clearHoverButtons();
                  }}
                >
                  <InboxIcon className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Buzón
                    </span>
                  )}
                </div>
              );
            } else if (section === "FORMS") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "FORMS" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("FORMS");
                    navigate("/business/backoffice/FORMS", { replace: true });
                    clearHoverButtons();
                  }}
                >
                  <ListTodo className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Formularios
                    </span>
                  )}
                </div>
              );
            } else if (section === "ASSISTANT") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "ASSISTANT" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("ASSISTANT");
                    navigate("/business/backoffice/assistant", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <BotMessageSquare className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Chat {brand === "MANTIS" ? "mantis" : "sandy"}
                    </span>
                  )}
                </div>
              );
            } else if (section === "DASHBOARD") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "DASHBOARD" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("DASHBOARD");
                    navigate("/business/backoffice/dashboard?idDashboard=1", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <ChartBarStacked className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Panel Principal
                    </span>
                  )}
                </div>
              );
            } else if (section === "BUDGET_DASHBOARD") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "BUDGET_DASHBOARD" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("BUDGET_DASHBOARD");
                    navigate("/business/backoffice/budget-dashboard", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <ChartBarStacked className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Presupuesto
                    </span>
                  )}
                </div>
              );
            } else if (section === "ARCHIVE") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "ARCHIVE" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("ARCHIVE");
                    navigate("/business/backoffice/archive", { replace: true });
                    clearHoverButtons();
                  }}
                >
                  <Folders className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Archivo
                    </span>
                  )}
                </div>
              );
            } else if (section === "CONTROL_PANEL") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "CONTROL_PANEL" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("CONTROL_PANEL");
                    navigate("/business/backoffice/control-panel", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <Flag className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Centro de control
                    </span>
                  )}
                </div>
              );
            } else if (section === "INVENTORY") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "INVENTORY" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("INVENTORY");
                    navigate("/business/backoffice/inventory", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <Box className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Inventario
                    </span>
                  )}
                </div>
              );
            } else if (section === "CONTROL_PANEL_P2O") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "CONTROL_PANEL_P2O" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("CONTROL_PANEL_P2O");
                    navigate("/business/backoffice/control-panel-p2o", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <LayoutPanelLeft className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Panel de Control
                    </span>
                  )}
                </div>
              );
            } else if (section === "PRODUCTS") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "PRODUCTS" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("PRODUCTS");
                    navigate("/business/backoffice/products", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <PackageSearch className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Productos
                    </span>
                  )}
                </div>
              );
            } else if (section === "FINANCIAL_ANALYSIS") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "FINANCIAL_ANALYSIS" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("FINANCIAL_ANALYSIS");
                    navigate("/business/backoffice/financial-analysis", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <BotMessageSquare className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Análisis Financiero IA
                    </span>
                  )}
                </div>
              );
            } else if (section === "PROJECTS") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "PROJECTS" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("PROJECTS");
                    navigate("/business/backoffice/projects", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <Box className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Proyectos
                    </span>
                  )}
                </div>
              );
            } else if (section === "OUTLETS") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "OUTLETS" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("OUTLETS");
                    navigate("/business/backoffice/outlets", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <Bot className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Outlets IA
                    </span>
                  )}
                </div>
              );
            } else if (section === "REQUISITIONS_DASHBOARD") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "REQUISITIONS_DASHBOARD" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("REQUISITIONS_DASHBOARD");
                    navigate("/business/backoffice/requisitions-dashboard", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <ChartBarStacked className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Dashboard Requisiciones
                    </span>
                  )}
                </div>
              );
            } else if (section === "CLIENT_TYPE_TAKTIK") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "CLIENT_TYPE_TAKTIK" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("CLIENT_TYPE_TAKTIK");
                    navigate("/business/backoffice/client-type-taktik", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <Blocks className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Taktik
                    </span>
                  )}
                </div>
              );
            } else if (section === "AGENTS") {
              return (
                <div
                  key={section}
                  className={`sidebar-item ${
                    activeSection === "AGENTS" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveSection("AGENTS");
                    navigate("/business/backoffice/agents", {
                      replace: true,
                    });
                    clearHoverButtons();
                  }}
                >
                  <Bot className="w-5 h-5 flex-shrink-0" />
                  {sidebarExpanded && (
                    <span className="ml-3 text-sm font-medium truncate">
                      Agentes
                    </span>
                  )}
                </div>
              );
            }
            return null;
          })}
        </nav>

        {/* Bottom Section */}
        <div className="border-t border-slate-200 dark:border-slate-700 p-3 space-y-2">
          {/* Language Selector - Integrado con Clean UI */}
          <LanguageSelectorClean
            currentLang={currentLang}
            isTranslating={isTranslating}
            isObserving={isObserving}
            sidebarExpanded={sidebarExpanded}
            onTranslate={translatePage}
          />

          {/* Separador visual */}
          <div className="border-t border-slate-200 dark:border-slate-700 my-2"></div>

          {/* Profile Section */}
          <div className="sidebar-item">
            <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
              <img
                src={props.mantisBusiness.logo || mantisLogo}
                alt="Business logo"
                className="w-full h-full object-cover"
              />
            </div>
            {sidebarExpanded && (
              <span className="ml-3 text-sm font-medium truncate">Perfil</span>
            )}
          </div>

          {/* Configuration */}
          <div
            className="sidebar-item"
            onClick={() => {
              setActiveSection("CONFIGURATION");
              navigate("/business/backoffice/configuration", {
                replace: true,
              });
              clearHoverButtons();
            }}
          >
            <Settings className="w-5 h-5 flex-shrink-0" />
            {sidebarExpanded && (
              <span className="ml-3 text-sm font-medium truncate">
                Configuración
              </span>
            )}
          </div>

          {/* Logout */}
          <div
            className="sidebar-item text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20"
            onClick={() => setShowLogoutModal(true)}
          >
            <LogOut className="w-5 h-5 flex-shrink-0" />
            {sidebarExpanded && (
              <span className="ml-3 text-sm font-medium truncate">
                Cerrar sesión
              </span>
            )}
          </div>

          {/* Theme Toggle - Hidden/Commented out as requested */}
          {/* 
          <div className="theme-toggle-container">
            <ThemeToggle onThemeChange={handleThemeChange} />
          </div>
          */}
        </div>
      </div>
      {(!props.mantisBusiness.requiresPlan && !props.mantisBusiness.inSetup) ||
      props.mantisBusiness.approved ? (
        <div
          className={`
            business-backoffice-viewpanel
            ${activeSection === "ASSISTANT" ? "assistant" : ""}
            ${!sidebarVisible && isMobile ? "ml-0" : ""}
          `}
          style={{
            width: calculateViewPanelWidth(),
            left: calculateViewPanelLeft(),
            transition: "all 0.3s ease-in-out",
          }}
        >
          {activeSection === "EMPLOYEES" && <Employees />}
          {activeSection === "DASHBOARD" && <BusinessDashboard />}
          {activeSection === "BUDGET_DASHBOARD" && <BudgetDashboard />}
          {activeSection === "ARCHIVE" && (
            <>
              {/* <Archive archiveUserId={archiveUserId} /> */}
              <ArchivesSection />
            </>
          )}
          {activeSection === "NOTIFICATIONS" && <BusinessNotifications />}

          {activeSection === "ASSISTANT" && (
            <BusinessAssistant
              sidebarExpanded={sidebarExpanded}
              helpPanelExpanded={helpPanelExpanded}
              sidebarCollapsedWidth={sidebarCollapsedWidth}
              sidebarExpandedWidth={sidebarExpandedWidth}
              helpPanelExpandedWidth={helpPanelExpandedWidth}
              helpPanelCollapsedWidth={helpPanelCollapsedWidth}
              sidebarTransitionTime={sidebarTransitionTime}
            />
          )}
          {activeSection === "CONTROL_PANEL" && <BusinessExtraction />}
          {activeSection === "INBOX" && <Inbox />}
          {activeSection === "FLOWS" && <Flows />}
          {activeSection === "FORMS" && <FormBuilderApp />}
          {activeSection === "FLOW_CREATOR" && <FlowCreator />}
          {activeSection === "FLOW_MANAGEMENT" && <FlowManagement />}
          {activeSection === "FILLING_FORM" && <DocumentActions />}
          {activeSection === "TAKTIK" && <DocumentManager />}

          {activeSection === "INVENTORY" && <InventoryManagement />}
          {activeSection === "CONTROL_PANEL_P2O" && <ControlPanel />}

          {activeSection === "PRODUCTS" && <Products clientId={clientId} />}
          {activeSection === "FINANCIAL_ANALYSIS" && <FinancialAnalysis />}
          {activeSection === "OUTLETS" && <Outlets />}
          {activeSection === "REQUISITIONS_DASHBOARD" && (
            <RequisitionsDashboard />
          )}
          {activeSection === "CLIENT_TYPE_TAKTIK" && (
            <ClientTypeTaktik
              mantisBusiness={props.mantisBusiness}
              token={props.token}
              userId={props.userId}
              user={props.user}
            />
          )}
          {activeSection === "AGENTS" && (
            <BusinessAgentsSection
              token={props.token}
              mantisBusinessId={props.mantisBusiness?._id}
            />
          )}
          {activeSection === "CONFIGURATION" && (
            <ConfigurationModal
              clientId={clientId}
              mantisBusiness={props.mantisBusiness}
              onClose={() => {
                setActiveSection("DASHBOARD");
                navigate("/business/backoffice/dashboard", { replace: true });
              }}
            />
          )}
          {/* <div className="yellow-blur"></div>
          <div className="blue-blur"></div> */}
        </div>
      ) : props.mantisBusiness.requiresPlan ? (
        <div
          className={`
            business-backoffice-viewpanel
            ${activeSection === "ASSISTANT" ? "assistant" : ""}
            ${!sidebarVisible && isMobile ? "ml-0" : ""}
          `}
          style={{
            width: calculateViewPanelWidth(),
            left: calculateViewPanelLeft(),
            transition: "all 0.3s ease-in-out",
          }}
        >
          <div
            style={{
              padding: "2rem",
              height: "100%",
              overflowY: "auto",
              background: "linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%)",
              minHeight: "100vh",
            }}
          >
            {props.mantisBusiness.businessPlan ? (
              <div
                style={{
                  maxWidth: "1200px",
                  margin: "0 auto",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {/* Header Card */}
                <div
                  style={{
                    background: "white",
                    borderRadius: "20px",
                    padding: "2.5rem",
                    marginBottom: "2rem",
                    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                  }}
                >
                  <h1
                    style={{
                      fontSize: "2rem",
                      marginBottom: "1rem",
                      fontWeight: "700",
                      color: "#f97316",
                    }}
                  >
                    {props.mantisBusiness.businessPlan.name}
                  </h1>
                  <p
                    style={{
                      fontSize: "1.1rem",
                      color: "#718096",
                      maxWidth: "600px",
                      margin: "0 auto",
                    }}
                  >
                    {props.mantisBusiness.businessPlan.description}
                  </p>
                </div>

                {/* Features Grid */}
                {/*<div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
                    gap: "2rem",
                    marginBottom: "2rem",
                  }}
                >
                  
                  <div
                    style={{
                      background: "white",
                      padding: "2rem",
                      borderRadius: "16px",
                      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                      border: "2px solid #e2e8f0",
                    }}
                  >
                    <div
                      style={{ textAlign: "center", marginBottom: "1.5rem" }}
                    >
                      <h3
                        style={{
                          fontSize: "1.3rem",
                          marginBottom: "1rem",
                          color: "#f97316",
                          fontWeight: "600",
                        }}
                      >
                        💳 Precios
                      </h3>
                    </div>
                    <div
                      style={{
                        fontSize: "2.5rem",
                        fontWeight: "800",
                        marginBottom: "0.5rem",
                        color: "#2d3748",
                        textAlign: "center",
                      }}
                    >
                      ${(() => {
                        // If there's a setup fee and upfront percentage, show upfront amount
                        if (props.mantisBusiness.businessPlan.setupFee && 
                            props.mantisBusiness.businessPlan.setupFeeUpfrontPercentage) {
                          const upfrontAmount = Math.ceil((props.mantisBusiness.businessPlan.setupFee * props.mantisBusiness.businessPlan.setupFeeUpfrontPercentage) / 100);
                          return upfrontAmount;
                        }
                        // If there's a setup fee and installments, show first installment
                        if (props.mantisBusiness.businessPlan.setupFee && 
                            props.mantisBusiness.businessPlan.setupFeeInstallments > 1) {
                          const firstInstallment = Math.ceil(props.mantisBusiness.businessPlan.setupFee / props.mantisBusiness.businessPlan.setupFeeInstallments);
                          return firstInstallment;
                        }
                        // Otherwise show regular plan price
                        return props.mantisBusiness.businessPlan.price;
                      })()}
                    </div>
                    <div
                      style={{
                        fontSize: "1rem",
                        color: "#718096",
                        marginBottom: "1rem",
                        textAlign: "center",
                      }}
                    >
                      {props.mantisBusiness.businessPlan.currency} /{" "}
                      {props.mantisBusiness.businessPlan.paymentCadence ===
                      "monthly"
                        ? "mensual"
                        : props.mantisBusiness.businessPlan.paymentCadence}
                    </div>
                    <div
                      style={{
                        fontSize: "0.9rem",
                        color: "#4a5568",
                        textAlign: "center",
                        padding: "1rem",
                        background: "#f7fafc",
                        borderRadius: "8px",
                        marginBottom: "1rem",
                      }}
                    >
                      <strong>Cargo de configuración:</strong> $
                      {props.mantisBusiness.businessPlan.setupFee}
                      {props.mantisBusiness.businessPlan.setupFeeInstallments >
                        1 && (
                        <span>
                          {" "}
                          (
                          {
                            props.mantisBusiness.businessPlan
                              .setupFeeInstallments
                          }{" "}
                          cuotas)
                        </span>
                      )}
                    </div>
                    {props.mantisBusiness.businessPlan
                      .setupFeeUpfrontPercentage && (
                      <div
                        style={{
                          fontSize: "0.9rem",
                          color: "#4a5568",
                          textAlign: "center",
                          padding: "1rem",
                          background: "#f7fafc",
                          borderRadius: "8px",
                        }}
                      >
                        <strong>Pago inicial:</strong>{" "}
                        {
                          props.mantisBusiness.businessPlan
                            .setupFeeUpfrontPercentage
                        }
                        % del cargo de configuración
                      </div>
                    )}
                  </div>

                  
                  <div
                    style={{
                      background: "white",
                      padding: "2rem",
                      borderRadius: "16px",
                      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                      border: "2px solid #e2e8f0",
                    }}
                  >
                    <div
                      style={{ textAlign: "center", marginBottom: "1.5rem" }}
                    >
                      <h3
                        style={{
                          fontSize: "1.3rem",
                          marginBottom: "1rem",
                          color: "#f97316",
                          fontWeight: "600",
                        }}
                      >
                        ⚡ Características del Plan
                      </h3>
                    </div>
                    <div style={{ marginBottom: "1rem" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1rem",
                          padding: "0.75rem",
                          background: "#f7fafc",
                          borderRadius: "8px",
                        }}
                      >
                        <span style={{ color: "#4a5568", fontWeight: "500" }}>
                          Usuarios máximos:
                        </span>
                        <span style={{ fontWeight: "700", color: "#2d3748" }}>
                          {props.mantisBusiness.businessPlan.maxUsers}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1rem",
                          padding: "0.75rem",
                          background: "#f7fafc",
                          borderRadius: "8px",
                        }}
                      >
                        <span style={{ color: "#4a5568", fontWeight: "500" }}>
                          Centros de costo:
                        </span>
                        <span style={{ fontWeight: "700", color: "#2d3748" }}>
                          {props.mantisBusiness.businessPlan.maxCostCenters}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1rem",
                          padding: "0.75rem",
                          background: "#f7fafc",
                          borderRadius: "8px",
                        }}
                      >
                        <span style={{ color: "#4a5568", fontWeight: "500" }}>
                          Órdenes de compra:
                        </span>
                        <span style={{ fontWeight: "700", color: "#2d3748" }}>
                          {props.mantisBusiness.businessPlan.maxPurchaseOrders}
                        </span>
                      </div>
                    </div>
                    {props.mantisBusiness.businessPlan.trialDays > 0 && (
                      <div
                        style={{
                          marginTop: "1rem",
                          padding: "1rem",
                          background:
                            "linear-gradient(135deg, #48bb78, #38a169)",
                          borderRadius: "8px",
                          textAlign: "center",
                        }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontWeight: "600",
                            fontSize: "1rem",
                          }}
                        >
                          🎉 {props.mantisBusiness.businessPlan.trialDays} días
                          de prueba gratuita
                        </span>
                      </div>
                    )}
                  </div>
                </div>*/}

                {/* Go to Pay Button Card */}
                <div
                  style={{
                    background: "white",
                    borderRadius: "20px",
                    padding: "2rem",
                    textAlign: "center",
                    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "2rem",
                      color: "#374151",
                      lineHeight: "1.6",
                    }}
                  >
                    <h2
                      style={{
                        fontSize: "1.75rem",
                        fontWeight: "700",
                        marginBottom: "1rem",
                        color: "#1f2937",
                      }}
                    >
                      ¡Bienvenido {props.user?.firstName || "Usuario"}!
                    </h2>
                    <p
                      style={{
                        fontSize: "1.125rem",
                        color: "#6b7280",
                        maxWidth: "600px",
                        margin: "0 auto",
                      }}
                    >
                      Ya estás a un paso de comenzar a entrenar tu agente de IA
                      Mantis. Continúa a la sección de pago que tenemos con
                      Stripe para activar tu cuenta.
                    </p>
                  </div>
                  <button
                    style={{
                      background: "linear-gradient(135deg, #f97316, #ea580c)",
                      color: "white",
                      border: "none",
                      padding: "1.25rem 3rem",
                      fontSize: "1.25rem",
                      fontWeight: "700",
                      borderRadius: "12px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 10px 30px rgba(249, 115, 22, 0.4)",
                      minWidth: "200px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-3px)";
                      e.target.style.boxShadow =
                        "0 15px 40px rgba(249, 115, 22, 0.6)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 10px 30px rgba(249, 115, 22, 0.4)";
                    }}
                    onClick={handlePaymentClick}
                  >
                    🚀 Ir a Pagar
                  </button>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  background: "white",
                  borderRadius: "20px",
                  padding: "3rem",
                  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
                }}
              >
                <h2
                  style={{
                    fontSize: "1.5rem",
                    textAlign: "center",
                    color: "#718096",
                  }}
                >
                  No hay información del plan de negocio disponible
                </h2>
              </div>
            )}
          </div>
          <div className="yellow-blur"></div>
          <div className="blue-blur"></div>
        </div>
      ) : props.mantisBusiness.inSetup ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            padding: "2rem",
            textAlign: "center",
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #ff6b35, #f7931e)",
              padding: "2rem 3rem",
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(255, 107, 53, 0.3)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)",
            }}
          >
            <h2
              style={{
                margin: 0,
                color: "white",
                fontSize: "1.75rem",
                fontWeight: "600",
                lineHeight: "1.4",
                textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              ¡Tu cuenta de empresa está en proceso de parametrización!
            </h2>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            padding: "2rem",
            textAlign: "center",
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #ff6b35, #f7931e)",
              padding: "2rem 3rem",
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(255, 107, 53, 0.3)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)",
            }}
          >
            <h2
              style={{
                margin: 0,
                color: "white",
                fontSize: "1.75rem",
                fontWeight: "600",
                lineHeight: "1.4",
                textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              ¡Tu cuenta de empresa está en proceso de verificación!
            </h2>
          </div>
        </div>
      )}

      {/* Toggle Sidebar Button - Solo visible en móviles */}
      {/* Hide mantis toggle button when viewing Roldan on mobile */}
      {isMobile &&
        !(
          isMobileDeviceType &&
          activeSection === "CLIENT_TYPE_TAKTIK" &&
          (props.mantisBusiness?.clientType === "ROLDAN" ||
            props.mantisBusiness?.clientType === "LOGISTICS_DEMO")
        ) && (
          <button
            className={`mobile-toggle-btn top-4 left-4 ${
              sidebarVisible ? "hidden" : "flex"
            }`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSidebarVisible(true);
            }}
            type="button"
          >
            <Menu />
          </button>
        )}

      {/* Hide Sidebar Button - Solo visible en móviles */}
      {isMobile && sidebarVisible && (
        <button
          className="mobile-toggle-btn top-4 !w-10 !h-10 !bg-red-500 hover:!bg-red-600"
          style={{
            left: sidebarExpanded
              ? `${sidebarExpandedWidth - 40}px`
              : `${sidebarCollapsedWidth - 40}px`,
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setSidebarVisible(false);
          }}
          type="button"
        >
          <X className="w-5 h-5" />
        </button>
      )}

      <HelpPanel
        expanded={helpPanelExpanded}
        setExpanded={setHelpPanelExpanded}
        helpPanelExpandedWidth={helpPanelExpandedWidth}
        helpPanelCollapsedWidth={helpPanelCollapsedWidth}
        helpPanelTransitionTime={helpPanelTransitionTime}
      />
      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        centered
      >
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            <h4
              style={{
                fontFamily: "Poppins, sans-serif",
                fontSize: "20px",
                marginBottom: 20,
              }}
            >
              ¿Estás seguro que deseas cerrar sesión?
            </h4>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <button
                className="business-logout-button"
                onClick={() => handleLogout()}
              >
                Sí
              </button>
              <button
                className="business-logout-button"
                onClick={() => setShowLogoutModal(false)}
              >
                No
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Translation Status - Integrado en el sidebar */}
    </div>
  );
}

export default connect(selectAuthState, mapDispatchToProps)(BusinessBackOffice);
